import { Codespace } from "../containers/DetectionAnalysis";

/** Burst times taken from the range test tool code (rangeTest.dat) */
const burstTimeMap = {
  "9001": {
    "8": 5.12,
    "27": 5.12,
    "35": 5.12,
    "45": 5.12,
    "1011": 4.96,
    "1028": 4.96,
    "1035": 4.96,
    "1044": 4.96,
    "1087": 4.96,
    "1143": 4.96,
    "1202": 4.96,
    "1203": 4.96,
    "13485": 5.02,
    "17488": 4.02,
    "19625": 5.02,
    "131971": 4.02,
    "180395": 4.02,
  },
  "1303": {
    "57340": 4.02,
    "61165": 4.02,
    "61180": 4.02,
    "61390": 4.02,
    "61405": 4.02,
    "64765": 4.02,
    "64990": 4.02,
    "65005": 4.02,
    "65215": 4.02,
    "65230": 4.02,
    "65440": 4.02,
    "65455": 4.02,
  },
  "1701": {
    "1063": 2.85,
    "1110": 2.85,
    "1113": 2.85,
    "2125": 2.85,
  },
  "1702": {
    "1063": 1.248,
    "1110": 1.248,
    "1113": 1.248,
    "2125": 1.248,
  },
  "1601": {
    "5": 2.6,
    "626": 2.6,
    "972": 3.1,
    "1066": 3.1,
    "1757": 2.58,
    "2459": 2.58,
    "2687": 2.58,
    "3315": 2.58,
    "4331": 2.58,
    "4632": 2.58,
    "7798": 2.58,
    "8137": 2.58,
    "8355": 3.1,
    "52087": 2.58,
    "52423": 2.58,
  },
};

type TxID = {
  codingId: string;
  transmitId: string;
};

const OP_CODESPACES = { OPI: 8001, OPS: 8002 };

function getTxID(fullId: string): TxID {
  const displayArray = fullId.split("-");
  if (displayArray.length > 2) {
    const txID: TxID = {
      codingId: displayArray[1],
      transmitId: displayArray[2],
    };
    return txID;
  } else {
    const txID: TxID = {
      codingId: OP_CODESPACES[displayArray[0]],
      transmitId: displayArray[1],
    };
    return txID;
  }
}

function getBurstTimeOverride(txID: TxID): number | null {
  let burst: number | null = null;
  if (txID.transmitId === undefined) return null;
  if (burstTimeMap[txID.codingId]) {
    burst = burstTimeMap[txID.codingId][txID.transmitId];
  }
  return burst;
}

function getCodeSpace(codespaces: Codespace[], codingId: string): Codespace | null {
  let codespace: Codespace | null = null;
  codespaces.forEach(cs => {
    if (cs.codingId == codingId) {
      codespace = cs;
    }
  });
  return codespace;
}

/** The expected time from start of one transmission to the next based on tag id and delays.
 * @returns Transmission interval (sec)
 */
export function getTxInterval({
  fullId,
  delayMin,
  delayMax,
  codespaces,
}: {
  fullId: string;
  delayMin: number;
  delayMax: number;
  codespaces: Codespace[];
}): number | null {
  if (!fullId) return null;

  let interval: number | null = null;

  const txID = getTxID(fullId);

  // get override, if it exists
  const burstTimeOverride = getBurstTimeOverride(txID);
  if (burstTimeOverride) {
    interval = (Number(delayMin) + Number(delayMax)) / 2 + burstTimeOverride;
  } else {
    const cs = getCodeSpace(codespaces, txID.codingId);
    if (cs) {
      interval = (Number(delayMin) + Number(delayMax)) / 2 + cs.averageBurstTimeS;
    }
  }

  return interval;
}
